angular
.module('app.views')
.controller('BoxcasterInventoryFormController', function($scope, $routeParams, $modalInstance, Boxcaster, Account, Config){
  $scope.config = Config;

  $scope.isSaving = false;

  $scope.isNew = !$routeParams.id;
  if (!$scope.isNew) {
    $scope.boxcaster = Boxcaster.get({id: $routeParams.id});
    $scope.boxcaster.$promise.then(b=> $scope.selectedAccount = b.account_id ? [Account.get({id: b.account_id})] : null);
  }

  $scope.searchAccounts = text=> Account.query({q: text}).$promise;

  $scope.ok = function() {
    $scope.isSaving = true;

    const b = $scope.boxcaster;
    const updated = {
      id: b.id,
      physical_status: b.physical_status,
      payment_status: b.payment_status,
      special_notes: b.special_notes
      //account_id: $scope.selectedAccount[0].id
    };
    return Boxcaster.update(updated, b=> $modalInstance.close(b));
  };

  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});



// WEBPACK FOOTER //
// ./views/boxcaster/boxcaster_inventory_form_controller.js